import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AiEntitlementState } from '../../states/ai-entitlement.state';

/**
 * Load AI Entitlement Use Case.
 *
 * Dedicated hydration trigger for the AI entitlement state. Fetches the AI
 * entitlement flag from the API once (no-op if already loaded). Use this in the
 * presentation layer to hydrate the state; read the value via
 * GetAiEntitlementStateUseCase.
 */
@Injectable({ providedIn: 'root' })
export class LoadAiEntitlementUseCase {
  private readonly _state = inject(AiEntitlementState);

  /**
   * Execute the use case.
   * @returns Observable that completes once the AI entitlement flag is hydrated.
   */
  public execute(): Observable<void> {
    return this._state.loadOnce();
  }
}
